import { FileApi } from './file.api';
import { UserApi } from './user.api';
import { Provider } from '@angular/core';
import { TenantApi } from './tenant.api';
import { MachineApi } from './machine.api';
import { GatewayApi } from './gateway.api';
import { SoftwareApi } from './software.api';

export const apiProviders: Provider[] = [
  TenantApi,
  UserApi,
  MachineApi,
  GatewayApi,
  FileApi,
  SoftwareApi,
];
